(() => {
  const normalizeColorKey = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[\/|–—_-]+/g, ' ')
    .replace(/\be\b/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const initGallery = (page) => {
    const stage = page.querySelector('[data-grpd-stage]');
    const count = page.querySelector('[data-grpd-count]');
    const allThumbs = [...page.querySelectorAll('[data-grpd-thumb]')];
    const prev = page.querySelector('[data-grpd-prev]');
    const next = page.querySelector('[data-grpd-next]');
    if (!stage || !allThumbs.length) return;

    let thumbs = [...allThumbs];
    let current = 0;

    const show = (index) => {
      if (!thumbs.length) return;
      current = (index + thumbs.length) % thumbs.length;
      const selected = thumbs[current];
      stage.src = selected.dataset.grpdSrc || stage.src;
      stage.alt = selected.dataset.grpdAlt || stage.alt;
      allThumbs.forEach((item) => {
        const active = item === selected;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (count) count.textContent = `${current + 1} / ${thumbs.length}`;
      const singleImage = thumbs.length <= 1;
      if (prev) prev.hidden = singleImage;
      if (next) next.hidden = singleImage;
    };

    const setColor = (color) => {
      const selectedKey = normalizeColorKey(color);
      const colorKeys = [...page.querySelectorAll('[data-grpd-color]')]
        .map((button) => normalizeColorKey(button.dataset.color))
        .filter(Boolean);

      if (!selectedKey || colorKeys.length <= 1) {
        const singleColorMatches = selectedKey
          ? allThumbs.filter((item) => normalizeColorKey(item.dataset.grpdAlt).includes(selectedKey))
          : [];
        thumbs = singleColorMatches.length ? singleColorMatches : [...allThumbs];
      } else {
        const matches = allThumbs.filter((item) => normalizeColorKey(item.dataset.grpdAlt).includes(selectedKey));
        const genericThumbs = allThumbs.filter((item) => {
          const altKey = normalizeColorKey(item.dataset.grpdAlt);
          return !colorKeys.some((colorKey) => altKey.includes(colorKey));
        });
        thumbs = matches.length ? matches : (genericThumbs.length ? genericThumbs : allThumbs.slice(0, 1));
      }

      allThumbs.forEach((item) => {
        item.hidden = !thumbs.includes(item);
      });
      show(0);
    };

    allThumbs.forEach((item) => item.addEventListener('click', () => {
      const index = thumbs.indexOf(item);
      if (index >= 0) show(index);
    }));
    prev?.addEventListener('click', () => show(current - 1));
    next?.addEventListener('click', () => show(current + 1));
    page.addEventListener('grpd:colorchange', (event) => setColor(event.detail?.color || ''));

    const initialColor = page.querySelector('[data-grpd-color].is-active')?.dataset.color || '';
    setColor(initialColor);
  };

  const initVariants = (page) => {
    const whatsappLinks = [...page.querySelectorAll('[data-grpd-whatsapp]')];
    const price = page.querySelector('[data-grpd-price]');
    const sizes = [...page.querySelectorAll('[data-grpd-size]')];
    const colors = [...page.querySelectorAll('[data-grpd-color]')];
    const colorName = page.querySelector('[data-grpd-color-name]');
    const cartForm = page.querySelector('[data-grpd-cart-form]');
    const variantInput = page.querySelector('[data-grpd-variant-input]');
    const cartButton = page.querySelector('[data-grpd-cart-add]');
    const cartLabel = page.querySelector('[data-grpd-cart-label]');
    const purchaseNote = page.querySelector('[data-grpd-purchase-note]');
    if (!whatsappLinks.length && !cartForm) return;

    const productName = whatsappLinks[0]?.dataset.productTitle || page.querySelector('h1')?.textContent?.trim() || 'Produto GioRun';
    let selectedColor = colors.find((item) => item.classList.contains('is-active'))?.dataset.color || '';
    let selectedSize = '';

    const resetCartSelection = () => {
      if (variantInput) variantInput.value = '';
      if (cartButton) cartButton.disabled = false;
      if (cartLabel) cartLabel.textContent = 'Comprar';
    };

    const updateWhatsapp = () => {
      const details = [];
      if (selectedColor) details.push(`Cor: ${selectedColor}`);
      if (selectedSize) details.push(`Tamanho: ${selectedSize}`);
      const selection = details.length ? ` Minha escolha: ${details.join(' · ')}.` : '';
      const message = `Olá! Tenho interesse no ${productName}.${selection} Gostaria de confirmar a disponibilidade e receber atendimento.`;
      whatsappLinks.forEach((link) => {
        const number = link.dataset.whatsappNumber || '5521982445694';
        link.href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
      });
    };

    colors.forEach((button) => button.addEventListener('click', () => {
      selectedColor = button.dataset.color || '';
      selectedSize = '';
      colors.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-checked', String(active));
      });
      if (colorName) colorName.textContent = selectedColor || 'Cor única';
      sizes.forEach((item) => {
        item.hidden = selectedColor ? item.dataset.color !== selectedColor : false;
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      resetCartSelection();
      page.dispatchEvent(new CustomEvent('grpd:colorchange', { detail: { color: selectedColor } }));
      updateWhatsapp();
    }));

    sizes.forEach((button) => button.addEventListener('click', () => {
      selectedSize = button.textContent.trim();
      sizes.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (price && button.dataset.price) price.textContent = button.dataset.price;
      if (variantInput) variantInput.value = button.dataset.variantId || '';
      if (cartButton) cartButton.disabled = false;
      if (cartLabel) cartLabel.textContent = 'Comprar';
      if (purchaseNote) {
        purchaseNote.textContent = 'Cor e tamanho selecionados. Você pode comprar ou falar com a GioRun.';
        purchaseNote.classList.remove('is-warning');
      }
      updateWhatsapp();
    }));

    cartForm?.addEventListener('submit', (event) => {
      if (!variantInput?.value) {
        event.preventDefault();
        resetCartSelection();
        if (purchaseNote) {
          purchaseNote.textContent = 'Selecione um tamanho antes de comprar.';
          purchaseNote.classList.add('is-warning');
        }
        sizes.find((item) => !item.hidden)?.focus();
      }
    });

    resetCartSelection();
    updateWhatsapp();
  };

  const init = () => {
    document.querySelectorAll('[data-grpd-page]').forEach((page) => {
      if (page.dataset.grpdReady) return;
      page.dataset.grpdReady = 'true';
      initGallery(page);
      initVariants(page);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
